const customEmailValidator = /^[\W]*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4}[\W]*;{1}[\W]*)*([\w+\-.%]+@[\w\-.]+\.[A-Za-z]{2,4})[\W]*$/
export default {
  getMessage (field, args) {
    return field
  },
  validate (value, args) {
    return customEmailValidator.test(value)
  }
}
